<template>
	<div class="printing-wrap">
		<!-- 报告单首页 -->
		<div class="printing" >
			<div class="report-corver">
				<img src="../assets/report-logo.png" alt="图片" />
			</div>
			<div class="report-dete">
				<img src="../assets/report-size.png" alt="图片" />
			</div>
			<div class="report-naologo">
				<img src="../assets/report-corver.png" alt="logo" />
			</div>
			<div class="report-age-sex">
				<ul>
					<li>姓名:</li>
					<li>性别:</li>
					<li>年龄:</li>
					<li>日期:</li>
				</ul>
				<div>
					<p>{{getPrintPageFirst.name}}</p>
					<p v-html="getPrintPageFirst.userSex==1?'女':'男'"></p>
					<p>{{getPrintPageFirst.userAge}}</p>
					<p>{{getPrintPageFirst.createtime}}</p>
				</div>
			</div>
			<div class="report-mumber">
				<p>报告单号：<b>{{getPrintPageFirst.cpNumber}}</b></p>
			</div>
		</div>
		<!-- 阅读指南-->
		<div class="printing">
			<h2 class="printing-header">
				<img src="../assets/read-guid.png" alt="图片" />
			</h2>
			<div class="read-guid" v-if="getPrintPage.isboy == 0">
				<p>脑功能检测从描述静态结构转变为探讨动态脑功能网络，为您的脑功能进行精准分析，提供脑功能图谱及优劣势解读，及专业的个性化提升方案，为您的脑效率和脑健康保驾护航。</p>
			</div>
			<div class="read-guid" v-if="getPrintPage.isboy == 1">
				<p>10-16岁是大脑发育的重要阶段，此阶段孩子正处于从具体运算阶段（具体思维）到形式运算阶段（抽象思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供脑功能图谱的优劣势解读和专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。</p>
			</div>
			<h3 class="printing-left">
				<img src="../assets/read-prin.png" alt="图片" />
			</h3>
			<div class="read-prin" v-if="getPrintPage.isboy == 0">
				<p class="read-prin-bot">首先，检测结果受环境和个人状态影响，越安静的环境、越良好的状态，检测结果和您的实际情况越符合。</p>
				<p>其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。</p>
			</div>
			<div class="read-prin" v-if="getPrintPage.isboy == 1">
				<p class="read-prin-bot">首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在10-16岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。</p>
				<p>其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。</p>
			</div>
			<h6 class="sore-table-title">表 得分与脑功能表现、人数占比对应表</h6>
			<div class="read-table">
				<table>
					<tr>
						<th>得分</th>
						<th>脑健康</th>
						<th>脑效率</th>
						<th>人数占比</th>
					</tr>
					<tr>
						<td>[75~100<span class="numjia">＋</span></td>
						<td>健康</td>
						<td>出色</td>
						<td>6%</td>
					</tr>
					<tr>
						<td>[60~75)</td>
 						<td>健康</td>
						<td>良好</td>
						<td>24%</td>
					</tr>
					<tr>
						<td>[25-60)</td>
						<td>亚健康</td>
						<td>中等</td>
						<td>64%</td>
					</tr>
					<tr>
						<td>[0-25)</td>
						<td>不健康</td>
						<td>欠佳</td>
						<td>6%</td>
					</tr>
				</table>
			</div>
			<div class="read-table-bot" v-if="getPrintPage.isboy == 0">
				<p>最后，本报告包含了3个检测项目的结果，并提供整合分析和单项分析，可阅读综合检测结果和分项检测结果。</p>
			</div>
			<div class="read-table-bot" v-if="getPrintPage.isboy == 1">
				<p>最后，本报告包含了3个脑功能检测项目的结果，并根据孩子的结果提供综合分析和单项分析。您可按照顺序先阅读综合脑功能结果与解读，再阅读单项脑功能结果与解读。</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 目录 -->
		<div class="printing">
			<h2 class="printing-header">
				<img src="../assets/table-co.png" alt="图片" />
			</h2>
			<div class="toc-mulu">
				<div class="zonghe-res">
					<ul>
						<li class="title-prin" v-if = "getPrintPage.zhdx == 1">
							<h6>1.综合脑功能结果与解读
							<b class="dast-xian">..............................................................</b>
							<span>03</span></h6>
						</li>
						<li class="title-prin-two" v-if = "getPrintPage.zhdx == 1">
							<ul>
								<li >
									<p>1.1检测结果全貌
									<b class="dast-xian">
									 ..........................................................................................................
									 </b>
									<span>03</span>
									</p>
								</li>
								<li>
									<p>1.2脑功能图谱：分析脑功能特点、优劣势及在生活的表现
									<b class="dast-xian">
		                             ...........................................
									 </b>
									<span>03</span>
									</p>
								</li>
								<li>
									<p>1.3综合建议：解读如何根据脑功能特点扬长避短
									<b class="dast-xian">
		                             .........................................................
									 </b>
									<span>05</span>
									</p>
								</li>
							</ul>
						</li>
						<li class="title-prin Single" v-if = "getPrintPage.zhdx == 1">
							<h6>2.单项脑功能结果与解读
							<b class="dast-xian">...............................................................</b>
							<span class="out1"></span></h6>
						</li>
						<li class="title-prin Single" v-if ="singleReport.status == 0">
							<h6>1.单项脑功能结果与解读
							<b class="dast-xian">...............................................................</b>
							<span class="out1"></span></h6>
						</li>
						<li class="zhixing-small" v-if = "getPrintPage.zhdx == 1">
							<p>2.1执行功能</p>
						</li>
						<li class="zhixing-small" v-if ="getshuzibijiao.status == 1 && singleReport.status == 0">
							<p>1.1执行功能</p>
						</li>
						<li class="title-prin-two zhixing" v-if = "getPrintPage.zhdx == 1">
							<ul>
								<li>
									<p>2.1.1单项脑功能结果
									<b class="dast-xian">
									 ..................................................................................................
									 </b>
									<span class="out3"></span>
									</p>
								</li>
								<li>
									<p>2.1.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                             .....................................................
									 </b>
									<span class="out4"></span>
									</p>
								</li>
								<li>
									<p v-if = "getshuzibijiao.brainEfficiency == '良好' || getshuzibijiao.brainEfficiency == '中等' ||getshuzibijiao.brainEfficiency == '欠佳'">2.1.3
									<b style="font-weight:normal" v-if = "getPrintPage.zhdx == 1">提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ..............................................................
									 </b>
									<span class="out5"></span>
									</p>

									<p v-if = "getshuzibijiao.brainEfficiency == '出色'">2.1.3
									<b style="font-weight:normal" v-if = "getPrintPage.zhdx == 1">如何发挥优势?</b>
									<b class="dast-xian">
		                             ...................................................................................................
									 </b>
									<span class="out5"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 无综合执行功能 -->
						<li class="title-prin-two zhixing" v-if ="getshuzibijiao.status == 1 && singleReport.status == 0">
							<ul>
								<li>
									<p>1.1.1单项脑功能结果
									<b class="dast-xian">
									 ..................................................................................................
									 </b>
									<span class="out3"></span>
									</p>
								</li>
								<li>
									<p>1.1.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                             .....................................................
									 </b>
									<span class="out4"></span>
									</p>
								</li>
								<li>
									<p v-if = "getshuzibijiao.brainEfficiency == '良好' || getshuzibijiao.brainEfficiency == '中等' ||getshuzibijiao.brainEfficiency == '欠佳'">1.1.3
									<b style="font-weight:normal" v-if = "singleReport.status == 0">提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ..............................................................
									 </b>
									<span class="out5"></span>
									</p>
									<p v-if = "getshuzibijiao.brainEfficiency == '出色'">1.1.3
									<b style="font-weight:normal"  v-if = "singleReport.status == 0">如何发挥优势?</b>
									
									<b class="dast-xian">
		                            ..................................................................................................
									 </b>
									<span class="out5"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 有综合情景记忆 -->
						<li class="zhixing-small" v-if = "getPrintPage.zhdx == 1 && qinjingjiyi.status == 1">
							<p>2.2情景记忆</p>
						</li>
						<li class="title-prin-two zhixing" v-if = "getPrintPage.zhdx == 1 && qinjingjiyi.status == 1">
							<ul>
								<li>
									<p>2.2.1单项脑功能结果
									<b class="dast-xian">
									....................................................................................................
									 </b>
									<span class="memory2"></span>
									</p>
								</li>
								<li>
									<p>2.2.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                               .......................................................
									 </b>
									<span class="memory3"></span>
									</p>
								</li>
								<li>
									<p v-if = "qinjingjiyi.brainEfficiency == '良好' || qinjingjiyi.brainEfficiency == '中等' ||qinjingjiyi.brainEfficiency == '欠佳'">
									2.2.3<b style="font-weight:normal">提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             .................................................................
									 </b>
									<span class="memory4"></span>
									</p>
									<p v-if = "qinjingjiyi.brainEfficiency == '出色'">
									2.2.3<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                             ..................................................................................................
									 </b>
									<span class="memory4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 有综合图形推理 -->
						<li class="zhixing-small" v-if = "getPrintPage.zhdx == 1 && luojituili.status == 1">
							<p>2.2图形推理</p>
						</li>
						<li class="title-prin-two zhixing" v-if = "getPrintPage.zhdx == 1 && luojituili.status == 1">
							<ul>
								<li>
									<p>2.2.1单项脑功能结果
									<b class="dast-xian">
									..................................................................................................
									 </b>
									<span class="reasoning2"></span>
									</p>
								</li>
								<li>
									<p>2.2.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                               .....................................................
									 </b>
									<span class="reasoning3"></span>
									</p>
								</li>
								<li>
									<p v-if = "luojituili.brainEfficiency == '良好' || luojituili.brainEfficiency == '中等' ||luojituili.brainEfficiency == '欠佳'">
									<b style="font-weight:normal"></b>2.2.3提升方案
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ...............................................................
									 </b>
									<span class="reasoning4"></span>
									</p>
									<p v-if = "luojituili.brainEfficiency == '出色'">
									<b style="font-weight:normal"></b>2.2.3如何发挥优势？
									<b class="dast-xian">
		                            ...................................................................................................
									 </b>
									<span class="reasoning4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 只有图形推理 -->
						<li class="zhixing-small" v-if = " singleReport.status == 0 && luojituili.status == 1 &&  getshuzibijiao.status == 0">
							<p>1.1图形推理</p>
						</li>
						<li class="title-prin-two zhixing" v-if = " singleReport.status == 0 && luojituili.status == 1 && getshuzibijiao.status == 0">
							<ul>
								<li>
									<p>1.1.1单项脑功能结果
									<b class="dast-xian">
									..................................................................................................
									 </b>
									<span class="reasoning2"></span>
									</p>
								</li>
								<li>
									<p>1.1.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                                 .....................................................
									 </b>
									<span class="reasoning3"></span>
									</p>
								</li>
								<li>
									<p v-if = "luojituili.brainEfficiency == '良好' || luojituili.brainEfficiency == '中等' ||luojituili.brainEfficiency == '欠佳'">1.1.3
									<b style="font-weight:normal">
									提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ...............................................................
									 </b>
									<span class="reasoning4"></span>
									</p>

									<p  v-if = "luojituili.brainEfficiency == '出色'">1.1.3
									<b style="font-weight:normal">
									如何发挥优势？</b>
									<b class="dast-xian">
		                             ...................................................................................................
									 </b>
									<span class="reasoning4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 第二个为图形推理 -->
						<li class="zhixing-small" v-if = " singleReport.status == 0 && luojituili.status == 1 && getshuzibijiao.status == 1">
							<p>1.2图形推理</p>
						</li>
						<li class="title-prin-two zhixing" v-if = " singleReport.status == 0 && luojituili.status == 1 && getshuzibijiao.status == 1">
							<ul>
								<li>
									<p>1.2.1单项脑功能结果
									<b class="dast-xian">
									..................................................................................................
									 </b>
									<span class="reasoning2"></span>
									</p>
								</li>
								<li>
									<p>1.2.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                               .......................................................
									 </b>
									<span class="reasoning3"></span>
									</p>
								</li>
								<li>
									<p v-if = "luojituili.brainEfficiency == '出色'">
									<b style="font-weight:normal"></b>1.2.3如何发挥优势？
									<b class="dast-xian">
		                             ...................................................................................................
									 </b>
									<span class="reasoning4"></span>
									</p>
									<p v-if = "luojituili.brainEfficiency == '良好' || luojituili.brainEfficiency == '中等' ||luojituili.brainEfficiency == '欠佳'">
									<b style="font-weight:normal"></b>1.2.3提升方案
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                              ...............................................................
									 </b>
									<span class="reasoning4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 只有情景记忆为1.1 -->
						<li class="zhixing-small" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0">
							<p>1.1情景记忆</p>
						</li>
						<li class="title-prin-two zhixing" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0">
							<ul>
								<li>
									<p>1.1.1单项脑功能结果
									<b class="dast-xian">
									..................................................................................................
									 </b>
									<span class="memory2"></span>
									</p>
								</li>
								<li>
									<p>1.1.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                               .......................................................
									 </b>
									<span class="memory3"></span>
									</p>
								</li>
								<li>
									<p v-if = "qinjingjiyi.brainEfficiency == '良好' || qinjingjiyi.brainEfficiency == '中等' ||qinjingjiyi.brainEfficiency == '欠佳'">
									1.1.3<b style="font-weight:normal">提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             .................................................................
									 </b>
									<span class="memory4"></span>
									</p>
									<p v-if = "qinjingjiyi.brainEfficiency == '出色'">
									1.1.3<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                             ..................................................................................................
									 </b>
									<span class="memory4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 无综合情景记忆 有执行功能 -->
						<li class="zhixing-small" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">
							<p>1.2情景记忆</p>
						</li>
						<li class="title-prin-two zhixing" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">
							<ul>
								<li>
									<p>1.2.1单项脑功能结果
									<b class="dast-xian">
									..................................................................................................
									 </b>
									<span class="memory2"></span>
									</p>
								</li>
								<li>
									<p>1.2.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                               .......................................................
									 </b>
									<span class="memory3"></span>
									</p>
								</li>
								<li>
									<p v-if = "qinjingjiyi.brainEfficiency == '良好' || qinjingjiyi.brainEfficiency == '中等' ||qinjingjiyi.brainEfficiency == '欠佳'">
									1.2.3<b style="font-weight:normal">提升方案</b>
									：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             .................................................................
									 </b>
									<span class="memory4"></span>
									</p>
									<p v-if = "qinjingjiyi.brainEfficiency == '出色'">
									1.2.3<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                             ..................................................................................................
									 </b>
									<span class="memory4"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 只有加工速度 -->
						<li class="zhixing-small" v-if="qinjingjiyi.status == 0 && getshuzibijiao.status == 0 && jagongsport.status == 1 && luojituili.status == 0">
							<p>1.1加工速度</p>
						</li>
						<li class="title-prin-two zhixing" v-if="qinjingjiyi.status == 0 && getshuzibijiao.status == 0 && jagongsport.status == 1&&luojituili.status == 0">
							<ul>
								<li>
									<p>1.1.1单项脑功能结果
									<b class="dast-xian">
									  ..................................................................................................
									 </b>
									<span class="speed1"></span>
									</p>
								</li>
								<li>
									<p>1.1.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                             .......................................................
									 </b>
									<span class="speed2"></span>
									</p>
								</li>
								<li>
									<p v-if = "jagongsport.brainEfficiency == '良好' || jagongsport.brainEfficiency == '中等' ||jagongsport.brainEfficiency == '欠佳'">1.1.3
									<b style="font-weight:normal">提升方案</b>:提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ..................................................................
									 </b>
									<span class="speed3"></span>
									</p>

									<p v-if = "jagongsport.brainEfficiency == '出色'">1.1.3
									<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                           ..................................................................................................
									 </b>
									<span class="speed3"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 加工速度为第二个 -->
						<li class="zhixing-small" v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">
							<p>1.2加工速度</p>
						</li>
						<li class="title-prin-two zhixing" v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">
							<ul>
								<li>
									<p>1.2.1单项脑功能结果
									<b class="dast-xian">
									  ..................................................................................................
									 </b>
									<span class="speed1"></span>
									</p>
								</li>
								<li>
									<p>1.2.2六六脑解读:分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                             .......................................................
									 </b>
									<span class="speed2"></span>
									</p>
								</li>
								<li>
									<p v-if = "jagongsport.brainEfficiency == '良好' || jagongsport.brainEfficiency == '中等' ||jagongsport.brainEfficiency == '欠佳'">1.2.3
									<b style="font-weight:normal">提升方案</b>:提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ..................................................................
									 </b>
									<span class="speed3"></span>
									</p>

									<p v-if = "jagongsport.brainEfficiency == '出色'">1.2.3
									<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                            ..................................................................................................
									 </b>
									<span class="speed3"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 加工速度为第三个 -->
						<li class="zhixing-small" v-if="getPrintPage.zhdx == 1 && jagongsport.status == 1">
							<p>2.3加工速度</p>
						</li>
						<li class="title-prin-two zhixing" v-if="getPrintPage.zhdx == 1 && jagongsport.status == 1">
							<ul>
								<li>
									<p>2.3.1单项脑功能结果
									<b class="dast-xian">
									  .....................................................................................................
									 </b>
									<span class="speed1"></span>
									</p>
								</li>
								<li>
									<p>2.3.2六六脑解读：分析脑功能在生活的表现及原因
									<b class="dast-xian">
		                             ........................................................
									 </b>
									<span class="speed2"></span>
									</p>
								</li>
								<li>
									<p v-if = "jagongsport.brainEfficiency == '良好' || jagongsport.brainEfficiency == '中等' ||jagongsport.brainEfficiency == '欠佳'">2.3.3
									<b style="font-weight:normal">提升方案</b>：提供专业的提升脑功能方案
									<b class="dast-xian">
		                             ..................................................................
									 </b>
									<span class="speed3"></span>
									</p>

									<p v-if = "jagongsport.brainEfficiency == '出色'">2.3.3
									<b style="font-weight:normal">如何发挥优势？</b>
									<b class="dast-xian">
		                             .....................................................................................................
									 </b>
									<span class="speed3"></span>
									</p>
								</li>
							</ul>
						</li>
						<!-- 有综合 -->
						<li class="title-prin know-now" v-if="getPrintPage.zhdx == 1">
							<h6>3.您知道吗？
							<b class="dast-xian">..................................................................................</b>
							<span class="understanding"></span></h6>
						</li>
						<li class="interesting" v-if="getPrintPage.zhdx == 1">
							<p>有趣案例：分析名人某项优势脑功能
								<b class="dast-xian">
	                             ...............................................................................
								 </b>
								<span class="understanding"></span>
							</p>
						</li>
						<!-- 无综合 -->
						<li class="title-prin know-now" v-if ="singleReport.status == 0">
							<h6>2.您知道吗？
							<b class="dast-xian">..................................................................................</b>
							<span class="understanding"></span></h6>
						</li>
						<li class="interesting" v-if ="singleReport.status == 0">
							<p>有趣案例：分析名人某项优势脑功能
								<b class="dast-xian">
	                             ................................................................................
								 </b>
								<span class="understanding"></span>
							</p>
						</li>
						<!-- 有综合 -->
						<li class="title-prin last" v-if="getPrintPage.zhdx == 1">
							<h6>4.后记
							<b class="dast-xian">.............................................................................................</b>
							<span class="lastpostscript"></span></h6>
						</li>
						<!-- 无综合 -->
						<li class="title-prin last" v-if ="singleReport.status == 0">
							<h6>3.后记
							<b class="dast-xian">..............................................................................................</b>
							<span class="lastpostscript"></span></h6>
						</li>
					</ul>
				</div>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 综合解读雷达图 -->
		<div class="printing" v-if="getPrintPage.zhdx == 1">
			<h2 class="printing-header">
				<img src="../assets/title-header.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
				<img src="../assets/title-left.png" alt="图片" />
			</h3>
			<p class="score-Introduction" v-if="getPrintPage.isboy == 1">
				您孩子的综合得分为<span>{{getPrintPage.score}}</span>，超过所处年龄段<span>{{getPrintPage.agegroup}}</span><span>{{getPrintPage.exceed}}%</span>的人，处于<span>{{getPrintPage.health}}</span>状态，脑效率处于<span>{{getPrintPage.efficiency}}</span>水平。以下是各项脑功能检测结果具体情况:
			</p>
			<p class="score-Introduction" v-if="getPrintPage.isboy == 0">
				您的综合得分为<span>{{getPrintPage.score}}</span>，超过所处年龄段<span>{{getPrintPage.agegroup}}</span><span>{{getPrintPage.exceed}}%</span>的人，处于
				<span>{{getPrintPage.health}}</span>状态，脑效率处于<span>{{getPrintPage.efficiency}}</span>水平。以下是各项脑功能检测结果具体情况:
			</p>
			<h6 class="table-title">
				表1 脑功能检测结果表
			</h6>
			<div class="printing-table">
				<table>
					<tr>
						<th>检测项目</th>
						<th>题目数</th>
						<th>正确数</th>
						<th>正确率</th>
						<th>反应时</th>
						<th>得分</th>
						<th>超过</th>
						<th>脑功能</th>
						<th>脑效率</th>
						<th>脑健康</th>
					</tr>
					<tr v-for="(item,index) in getscoreList">
						<td>{{item.gameName}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.number}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.correctNum}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.correctRate}}%</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.time}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.score}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.exceed}}%</td>   
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainFunction}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainEfficiency}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainHealth}}</td>
					</tr>
				</table>
			</div>
			<p class="coefficient-Interpretation" v-if="getPrintPage.isboy == 0">
				<b>系数解读:</b> a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您的该项脑功能处于不健康状态，蓝色字体表示您的该项脑功能处于亚健康状态。
			</p>
			<p class="coefficient-Interpretation" v-if="getPrintPage.isboy == 1">
				<b>系数解读:</b> a.反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。
			</p>
			<h3 class="printing-map">
				<img src="../assets/brain.png" alt="图片" />
			</h3>
			<p class="brain-bot" v-if="getPrintPage.isboy == 0">
				根据对您的数字比较任务、人物情景任务、数字符号转换任务这三项任务表现的综合分析，您的脑功能模式属于<span>{{this.brainsuggest.brainType}}</span>。见图1:
			</p>
			<p class="brain-bot" v-if="getPrintPage.isboy == 1">
				根据对您孩子的数字比较任务、图形推理任务、数字符号转换任务这三项任务表现的综合分析，您孩子的脑功能模式属于<span>{{this.brainsuggest.brainType}}</span>。见图1:
			</p>
			<div class="echart-barin">
				<div id="radarChart" :style="{width: '400px', height: '400px'}"></div>
			</div>
			<div class="brain-img-bot">
				图1 脑功能图谱
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 综合解读建议 -->
		<div class="printing" v-if="getPrintPage.zhdx == 1">
			<h2 class="printing-header">
				<img src="../assets/title-header.png" alt="图片" />
			</h2>
			<h6 class="factor">图谱解读</h6>
			<div class="map-inter">
				<p>{{brainsuggest.unscramble}}</p>
				<p>{{brainsuggest.reason}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 综合解读建议 2-->
		<div class="printing" v-if="getPrintPage.zhdx == 1">
			<h2 class="printing-header">
				<img src="../assets/title-header.png" alt="图片" />
			</h2>
			<h3 class="printing-map">
				<img src="../assets/Mind.png" alt="图片" />
			</h3>
			<div class="Synthesis-mind" v-if="getPrintPage.isboy == 0">
				<p>根据您的综合得分和脑功能图谱综合分析的结果，您的脑功能处于<span>{{getPrintPage.efficiency}}</span>水平。</p>
				<p>{{brainsuggest.advice}}</p>
				<p>{{brainsuggest.prewarning}}</p>
			</div>
			<div class="Synthesis-mind" v-if="getPrintPage.isboy == 1">
					<p>根据孩子的综合得分和脑功能图谱综合分析的结果，他／她的综合脑功能处于<span>{{getPrintPage.efficiency}}</span>水平</p>
				<p>{{brainsuggest.advice}}</p>
				<p>{{brainsuggest.prewarning}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 单项功能解读 执行功能-->
		<div class="printing" v-if="getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="Summarized" v-if = "getshuzibijiao.isboy == 1">
				<p>
					本次检测包含执行功能、逻辑推理和加工速度三项脑功能项目，以下是对您孩子的各项脑功能的测评结果及详细解读。
				</p>
			</div>
			<div class="Summarized" v-if = "getshuzibijiao.isboy == 0">
				<p>
					本次检测包含执行功能、加工速度和情景记忆三项脑功能项目，以下是您的各项脑功能的测评结果及详细解读。
				</p>
			</div>
			<h3 class="Summarized-Features"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/carried-out.png" alt="图片" />
			</h3>
			<h3 class="Summarized-Features" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">
				<img src="../assets/zhixing-one.png" alt="图片" />
			</h3>
			<div class="Summarized-fea">
				<p>执行功能（executive function）指个体计划、面对诱惑的反应抑制能力、自我调节及监控等能力，执行功能涉及背外侧前额叶、前扣带回等。在日常学习、工作与生活中，做饭、开车、学习及工作规划等都会用到此功能。例如，出去旅游时，我们事先需要在网上或通过朋友介绍来搜集信息做乘车线路、旅游景点先后顺序等各种攻略，但是计划赶不上变化，我们有时会因为各种原因不能按原计划的线路去游玩，这时候就需要灵活调整自己的计划，以选择最有利的出游线路，这种旅游时做计划、灵活调整计划的能力就是我们讲的执行功能。数字比较测评任务
				（NumericComparison）是根据任务切换（Task-Switch）范式（Logan et al., 2003）改编的，通过计算从一个任务切换到另一个任务的反应时和正确率来检测个体的执行功能。</p>
			</div>
			<div class="Summarized-res">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.1.1 检测结果</a>
				<a v-if="getshuzibijiao.status == 1  && singleReport.status == 0">1.1.1 检测结果</a>
			</div>
			<div class="Summarized-Synthesis" v-if = "getshuzibijiao.isboy == 1">
				<p>在数字比较任务中，我们设置了4个难度等级，如表<span v-if="getPrintPage.zhdx == 1">2</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">1</span>。难度等级越高，表明需要您孩子投入的认知资源越多。</p>
			</div>
			<div class="Summarized-Synthesis" v-if = "getshuzibijiao.isboy == 0">
				<p>在数字比较任务中，我们设置了4个难度等级，如表<span v-if="getPrintPage.zhdx == 1">2</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">1</span>。难度等级越高，表明需要您投入的认知资源越多。</p>
			</div>
			<h6 class="table-title">
				表<span v-if="getPrintPage.zhdx == 1">2</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">1</span> 数字比较任务难度等级表
			</h6>
			<div class="Rating-table">
				<table>
					<tr>
						<th>难度等级</th>
						<th>条件</th>
						<th>认知资源</th>
					</tr>
					<tr>
						<td>1</td>
						<td>数字多少与尺寸大小匹配，判断大小</td>
						<td>任务切换，知觉加工</td>
					</tr>
					<tr>
						<td>2</td>
						<td>数字多少与尺寸大小匹配，判断多少</td>
						<td>任务切换，抽象加工</td>
					</tr>
					<tr>
						<td>3</td>
						<td>数字多少与尺寸大小不匹配，判断多少</td>
						<td>任务切换和冲突抑制，知觉加工</td>
					</tr>
					<tr>
						<td>4</td>
						<td>数字多少与尺寸大小不匹配，判断大小</td>
						<td>任务切换和冲突抑制，抽象加工</td>
					</tr>
				</table>
			</div>
			<!-- 数字比较 -->
			<div class="tableindex" v-if = "getshuzibijiao.isboy == 1">
				<p>通过各项指标计算，您孩子的执行功能得分为<span>{{getshuzibijiao.score}}</span>，超过所处年龄段<span>{{getshuzibijiao.agegroup}}</span>
				<span>{{getshuzibijiao.exceed}}</span>%
				的人，孩子的此项脑功能<span>{{getshuzibijiao.brainHealth}}</span>，脑效率处于<span>{{getshuzibijiao.brainEfficiency}}</span>水平。在正确率和反应时上的具体表现如下:</p>
			</div>
			<div class="tableindex" v-if = "getshuzibijiao.isboy == 0">
				<p>通过各项指标计算，您的执行功能得分为<span>{{getshuzibijiao.score}}</span>，超过所处年龄段<span>{{getshuzibijiao.agegroup}}</span>
				<span>{{getshuzibijiao.exceed}}</span>%
				的人，您的此项脑功能<span>{{getshuzibijiao.brainHealth}}</span>，脑效率处于<span>{{getshuzibijiao.brainEfficiency}}</span>水平。在正确率和反应时上的具体表现如下:</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried1"></a>
			</div>
		</div>
		<!-- 单项解读 执行功能 柱状图表 -->
		<div class="printing" v-if="getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="echart-performed-one">
				<p>（1）反应时上的表现。（图<span v-if="getPrintPage.zhdx == 1">2</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">1</span>）</p>
			</div>
			<div class="echart-reaction-one" :style="{width: '700px', height: '450px'}" id="histogram"></div>
			<div class="difficulty">
				<p>难度等级</p>
				<h6>图 <span v-if="getPrintPage.zhdx == 1">2</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">1</span>各难度等级的反应时</h6>
			</div>
			<div class="echart-performed-two" >
				<p>（2）正确率上的表现。（图<span v-if="getPrintPage.zhdx == 1">3</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">2</span>）</p>
			</div>
			<div class="echart-reaction-two" :style="{width: '700px', height: '450px'}" id="hisRight"></div>
			<div class="difficulty">
				<p>难度等级</p>
				<h6>图 <span v-if="getPrintPage.zhdx == 1">3</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">2</span> 各难度等级的正确率</h6>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried2"></a>
			</div>
		</div>
		<!-- 单项脑功能解读 执行功能脑图 -->
		<div class="printing" v-if="getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="nerve">
				<p v-if="getshuzibijiao.isboy == 1">
				大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您孩子在数字比较任务中的成绩可推测出孩子的执行功能脑网络状态{{getshuzibijiao.brainEfficiency}}，如图
				<span v-if="getPrintPage.zhdx == 1">4</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">3</span>。
				</p>
				<p v-if="getshuzibijiao.isboy  == 0">
					大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您在数字比较任务中的成绩可推测出您执行控制网络状态{{getshuzibijiao.brainEfficiency}}，如图
					<span v-if="getPrintPage.zhdx == 1">4</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">3</span>。
				</p>
			</div>
			<div class="brain-figure">
				<img v-if="getshuzibijiao.cid == 4" src="../assets/naoz-1.png" alt="图片" />
				<img v-if="getshuzibijiao.cid == 3" src="../assets/naoz-2.png" alt="图片" />
				<img v-if="getshuzibijiao.cid == 2" src="../assets/naoz-3.png" alt="图片" />
				<img v-if="getshuzibijiao.cid == 1" src="../assets/naoz-4.png" alt="图片" />
			</div>
			<h6 class="brain-des">图<span v-if="getPrintPage.zhdx == 1">4</span><span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 ">3</span>执行功能脑网络图</h6>
			<div class="six-res">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.1.2六六脑解读</a>
				<a v-if="getshuzibijiao.status == 1  && singleReport.status == 0">1.1.2六六脑解读</a>
			</div>
			<h6 class="nao-effec">执行功能与脑效率、脑健康</h6>
			<div class="nao-hel">
				<p>{{getshuzibijiao.efficiency}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried3"></a>
			</div>
		</div>
		<!-- 单项脑功能执行功能 影响因素 -->
		<div class="printing" v-if="getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<h6 class="carried-out">影响执行功能的因素</h6>
			<div class="carried-sport" v-if="getshuzibijiao.isboy  == 0">
				<p>缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。《美国医学会杂志》曾刊载过一项研究，大脑在25岁发育达到顶峰，30岁后大脑便开始逐渐衰老，每年缩小0.3%，人体新陈代谢也随之逐渐变缓。而长期睡眠不足、用脑习惯不好，学习、工作压力过大，都会导致大脑的疲劳，导致执行功能降低。此外，脑损伤、脑疾病、躯体问题等任何引起大脑皮层功能和结构异常的因素均会引起执行功能的下降。执行功能障碍常见于额叶-皮质下环路受损，执行功能良好的基础是大脑皮层的正常功能，躯体疾病和脑疾病会引起神经活动的异常，损伤大脑结构和功能，造成执行功能的下降。</p>
			</div>
			<div class="carried-sport" v-if="getshuzibijiao.isboy == 1">
				<p>缺乏运动、睡眠不足、不良生活习惯、脑疲劳或大脑发育不良等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降。Friedman等研究者们对916名双胞胎进行随访研究，结果发现儿童的睡眠问题与青春期的执行控制功能相关，孩子对睡眠的生理需要量多余成人，睡眠不足对孩子执行功能的损害尤为突出，具体表现为计划性差、思维僵化、注意力不足、多动、冲动和情绪多变；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，与执行功能相对应的执行控制网络，在整个儿童和青少年时期都是不断发展的，各种原因引起的神经系统发育不良，尤其是执行控制网络对应大脑皮层功能和结构发育不良，会导致执行功能上的表现较差。</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried4"></a>
			</div>
		</div>
		<!-- 单项脑功能解读 执行功能提升表格 -->
		<div class="printing" v-if="getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="enhance-pro">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getshuzibijiao.brainEfficiency == '良好' || getshuzibijiao.brainEfficiency == '中等' ||getshuzibijiao.brainEfficiency == '欠佳'">
					<a v-if = "getPrintPage.zhdx == 1">2.1.3 提升方案</a>
					<a v-if="getshuzibijiao.status == 1  && singleReport.status == 0">1.1.3 提升方案</a>
				</a>
				<a v-if = "getshuzibijiao.brainEfficiency == '出色' ">
					<a v-if = "getPrintPage.zhdx == 1">2.1.3如何发挥优势？</a>
					<a v-if="getshuzibijiao.status == 1  && singleReport.status == 0">1.1.3如何发挥优势？</a>
				</a>
			</div>
			<p class="Suggest">{{getshuzibijiao.advice}}</p>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in shuzibijiaoList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 情景记忆  表格 -->
		<div class="printing" v-if="qinjingjiyi.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="qinjingjiyi.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<!-- 有综合 -->
			<h3 class="printing-left" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/scene.png" alt="图片" />
			</h3>
			<!-- 单项唯一 -->
			<h3 class="printing-left" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0 && jagongsport.status == 0 && singleReport.status == 0">
				<img src="../assets/qingjing-one-one.png" alt="图片" />
			</h3>
			<!-- 有两个 -->
			<h3 class="printing-left" v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">
				<img src="../assets/qingjign-one.png" alt="图片" />
			</h3>
			<div class="scene-intr">
				<p>情景记忆（Episodic Memory）是指对个人亲身经历的、发生在一定时间和地点的事件（情景）的记忆。比如，对昨天在公园里会见一位朋友的记忆就是情景记忆。</p>
			</div>
			<div class="scene-res">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.2.1 检测结果</a>
				<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0  && singleReport.status == 0">1.1.1 检测结果</a>
				<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1  &&  singleReport.status == 0">1.2.1 检测结果</a>
			</div>
			<div class="Detection-res">
				<p>本检测项目通过回忆人像与地点、事件的联结记忆考察情景记忆，共进行两次学习-回忆。</p>
				<p>通过两次记忆核算，您的情景记忆得分为<span>{{qinjingjiyi.score}}</span>，超过所处年龄段<span>{{qinjingjiyi.agegroup}}</span><span>{{qinjingjiyi.exceed}}</span>%的人，您的此项脑功能<span>{{qinjingjiyi.brainHealth}}</span>，脑效率处于<span>{{qinjingjiyi.brainEfficiency}}</span>水平。两次记忆情况具体如下:</p>
			</div>
			<h6 class="table-title">
				情景记忆检测结果
			</h6>
			<div class="Detection-table">
				<table>
					<tr>
						<th></th>
						<th></th>
						<th>总数</th>
						<th>正确数</th>
						<th class="bordernone-right">正确率</th>
					</tr>
					<tr>
						<td class="rowspan-td" rowspan="3">第一次</td>
						<td>人像地点联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta1}}</td>
						<td>{{qinjingjiyi.rightaRate1}}%</td>
					</tr>
					<tr>
						<td>人像事件联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta2}}</td> 
						<td>{{qinjingjiyi.rightaRate2}}%</td>
					</tr>
					<tr>
						<td>人像地点事件联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta3}}</td>
						<td>{{qinjingjiyi.rightaRate3}}%</td>
					</tr>
					<tr>
						<td class="rowspan-td" rowspan="3">第二次</td>
						<td>人像地点联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta4}}</td>
						<td>{{qinjingjiyi.rightaRate4}}%</td>
					</tr>
					<tr>
						<td>人像事件联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta5}}</td>
						<td>{{qinjingjiyi.rightaRate5}}%</td>
					</tr>
					<tr>
						<td>人像地点事件联结</td>
						<td>6</td>
						<td>{{qinjingjiyi.righta6}}</td>
						<td>{{qinjingjiyi.rightaRate6}}%</td>
					</tr>
				</table>
			</div>
			
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num scene1"></a>
			</div>
		</div>
		<!-- 单项解读 情景记忆2.2.2 -->
		<div class="printing" v-if="qinjingjiyi.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="qinjingjiyi.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="nerv-show">
				<p>大量神经科学和临床研究表明，参与情景记忆的脑区，主要包含内侧前额叶、后扣带/楔前叶、角回、海马等。根据您在人物情景中的成绩可推测出您情景记忆网络状态<span>{{qinjingjiyi.brainEfficiency}}</span>，如图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && qinjingjiyi.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && qinjingjiyi.status == 1">3</span>
				<span v-if = "getPrintPage.zhdx == 1">5</span>。</p>
			</div>
			<div class="nao-memory">
				<img v-if="qinjingjiyi.cid == 4" src="../assets/naoq-1.png" alt="图片" />
				<img v-if="qinjingjiyi.cid == 3" src="../assets/naoq-2.png" alt="图片" />
				<img v-if="qinjingjiyi.cid == 2" src="../assets/naoq-3.png" alt="图片" />
				<img v-if="qinjingjiyi.cid == 1" src="../assets/naoq-4.png" alt="图片" />
			</div>
			<h6 class="nao-memory-bot">图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && qinjingjiyi.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && qinjingjiyi.status == 1">3</span>
				<span v-if = "getPrintPage.zhdx == 1">5</span> 情景记忆脑网络图</h6>
			<div class="enhance-pro">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.2.2 六六脑解读</a>
				<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0 && singleReport.status == 0">1.1.2 六六脑解读</a>
				<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">1.2.2 检测结果</a>
			</div>
			<h6 class="nao-enhance">情景记忆与脑效率、脑健康</h6>
			<div class="memory-error">
				<p>{{qinjingjiyi.efficiency}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num scene2"></a>
			</div>
		</div>
		<div class="printing" v-if="qinjingjiyi.status == 1">	
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="qinjingjiyi.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<h6 class="factor">影响情景记忆的因素</h6>
			<div class="age-factor">
				<p>年龄是影响情景记忆的重要因素，记忆能力随着年龄增加出现衰退。近年来利用fMRI研究青年人和老年人情景记忆的差异，认为老年人记忆力的下降在一定程度上是因为对中颞叶的利用下降，记忆衰退和海马区的激活有相关性，Cabeza 的研究小组发现在平均70岁的老年人组海马区在情景提取过程比平均年龄23岁的年轻人激活减低。缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都会导致情景记忆减退。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了记忆力的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，在事物间多进行形象化深度加工，可以有助于情景记忆的增强。例如，记忆一张老爷爷图片、地点：深圳、事件：跳舞这些信息时，可以通过联结一名时髦的老爷爷在繁华的深圳广场上跳广场舞，十分开心。总之，良好的联结记忆策略可以帮助增强情景记忆。</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num scene3"></a>
			</div>
		</div>
		<!-- 单项解读 情景记忆提升表格 -->
		<div class="printing" v-if="qinjingjiyi.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="qinjingjiyi.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="play-adv">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "qinjingjiyi.brainEfficiency == '良好' || qinjingjiyi.brainEfficiency == '中等' ||qinjingjiyi.brainEfficiency == '欠佳'">
					<a v-if = "getPrintPage.zhdx == 1">2.2.3 提升方案</a>
					<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0 && singleReport.status == 0">1.1.3 提升方案</a>
					<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">1.2.3 提升方案</a>
				</a>
				<a v-if = "qinjingjiyi.brainEfficiency == '出色' ">
					<a v-if = "getPrintPage.zhdx == 1">2.2.3如何发挥优势？</a>
					<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 0 && singleReport.status == 0">1.1.3如何发挥优势？</a>
					<a v-if="qinjingjiyi.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">1.2.3如何发挥优势？</a>

				</a>
			</div>
				<p class="Suggest">{{qinjingjiyi.advice}}</p>
			<div class="sanjaio-bot"></div>
			<div class="sport-table">
				<table>
					<tr v-for ="(item,index) in renwuqingjign">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num scene4"></a>
			</div>
		</div>
		<!-- 逻辑推理	表格 介绍   -->
		<div class="printing" v-if="luojituili.status == 1">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<h3 class="printing-left" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/lj-talent.png" alt="图片" />
			</h3>
			<h3 class="printing-left" v-if="luojituili.status == 1 && singleReport.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">
				<img src="../assets/tuxing-one.png" alt="图片" />
			</h3>
			<h3 class="printing-left" v-if="luojituili.status == 1 && singleReport.status == 0 && getshuzibijiao.status == 1">
				<img src="../assets/tuxin-tw.png" alt="图片" />
			</h3>
			<div class="scene-intr">
				<p>逻辑推理（Logical Reasoning）是指一种根据周围环境和活动找出其内在的逻辑关系从而推理出符合逻辑关系的结论的能力，逻辑推理涉及背外侧前额叶、后顶叶、前扣带、脑岛等。在日常学习和生活中，经常需要用到此能力。比如，日常生活中一个人做事或说话是否有条理，就需要逻辑推理能力。逻辑推理是智力的一般因素，是与人的问题解决、清晰知觉、思维，发现和利用自己所需信息以及有效地适应社会生活的能力有关。图形推理测评任务（Figure reasoning task）选自著名的瑞文推理测验（Standard Progressive Matrices，SPM），是英国心理学家瑞文(Raven)于1938年设计的一种非文字智力测验，通过计算个体在一定时间内理性判断的正确数来检测个体的逻辑推理能力，被广泛应用于人才选拨、学业成就、智商、大脑发育水平的预测和评估中。</p>
			</div>
			<div class="scene-res">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.2.1 检测结果</a>
				<a v-if="luojituili.status == 1 && getshuzibijiao.status == 0  && singleReport.status == 0">1.1.1 检测结果</a>
				<a v-if="luojituili.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0">1.2.1 检测结果</a>
			</div>
			<div class="Summarized-Synthesis">
				<p>在图形推理任务中，我们设置了5个难度等级。难度等级越高，表明需要您孩子投入的认知资源越多，表
				<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">2</span>
				<span v-if = "getPrintPage.zhdx == 1">3</span>。</p>
			</div>
			<h6 class="table-title">
				表
				<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">2</span>
				<span v-if = "getPrintPage.zhdx == 1">3</span>图形推理任务各难度等级测试结果
			</h6>
			<div class="Rating-table-luoji">
				<table>
					<tr>
						<th>难度等级</th>
						<th>认知资源</th>
						<th>总题目数</th>
						<th>正确率</th>
					</tr>
					<tr>
						<td>1</td>
						<td>知识辨别</td>
						<td>2</td>
						<td>{{luojituili.right1}}%</td>
					</tr>
					<tr>
						<td>2</td>
						<td>类同比较</td>
						<td>2</td>
						<td>{{luojituili.right2}}%</td>
					</tr>
					<tr>
						<td>3</td>
						<td>比较推理</td>
						<td>2</td>
						<td>{{luojituili.right3}}%</td>
					</tr>
					<tr>
						<td>4</td>
						<td>系列关系</td>
						<td>2</td>
						<td>{{luojituili.right4}}%</td>
					</tr>
					<tr>
						<td>5</td>
						<td>抽象推理</td>
						<td>2</td>
						<td>{{luojituili.right5}}%</td>
					</tr>
				</table>
			</div>
			<div class="Detection-res">
				<p>通过各项指标计算，您孩子的逻辑推理得分为<span>{{luojituili.score}}</span>，超过所处年龄段<span>{{luojituili.agegroup}}</span><span>{{luojituili.exceed}}</span>%的人，孩子的此项脑功能<span>{{luojituili.brainHealth}}</span>，脑效率处<span>{{luojituili.brainEfficiency}}</span>水平。在正确率和反应时的具体表现如下：</p>
			</div> 
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic1"></a>
			</div>
		</div>
		<!-- 逻辑推理柱状图 -->
		<div class="printing" v-if="luojituili.status == 1">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
				<div class="echart-performed-one">
				<p>（1）反应时上的表现。（图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">4</span>
				<span v-if = "getPrintPage.zhdx == 1">5</span>）</p>
				</div>
			<div class="echart-reaction-one" :style="{width: '700px', height: '450px'}" id="Graphics">
			</div>
			<div class="difficulty">
				<p>难度等级</p>
				<h6>图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">1</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">4</span>
				<span v-if = "getPrintPage.zhdx == 1">5</span> 各难度等级的反应时</h6>
			</div>
			<div class="echart-performed-two">
				<p>（2）正确率上的表现。（图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">2</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">5</span>
				<span v-if = "getPrintPage.zhdx == 1">6</span>）</p>
			</div>
			<div class="echart-reaction-two" :style="{width: '700px', height: '450px'}" id="reasoning">
			</div>
			<div class="difficulty">
				<p>难度等级</p>
				<h6>图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">2</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">5</span>
				<span v-if = "getPrintPage.zhdx == 1">6</span> 各难度等级的正确率</h6>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic2"></a>
			</div>
		</div>
		<!-- 逻辑推理  脑网络图-->
		<div class="printing" v-if="luojituili.status == 1">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="nerve">
				<p>
					逻辑推理涉及的脑网络为额顶整合网络（parieto-frontal integration theory, P-FIT），在个体中，逻辑推理能力涉及脑区为背外侧前额叶、后顶叶、前扣带、脑岛等。这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络、注意网络和外显网络。根据您孩子在图形推理任务中的成绩可推测出孩子的逻辑推理脑网络状态<span>{{luojituili.brainEfficiency}}</span>，如图7。
				</p>
			</div>
			<div class="brain-figure">
				<img v-if="luojituili.cid == 4" src="../assets/naol-1.png" alt="图片" />
				<img v-if="luojituili.cid == 3" src="../assets/naol-2.png" alt="图片" />
				<img v-if="luojituili.cid == 2" src="../assets/naol-3.png" alt="图片" />
				<img v-if="luojituili.cid == 1" src="../assets/naol-4.png" alt="图片" />
			</div>
			<h6 class="brain-des">图<span v-if = "getshuzibijiao.status == 0 && singleReport.status == 0 && luojituili.status == 1">3</span>
				<span v-if = "getshuzibijiao.status == 1 && singleReport.status == 0 && luojituili.status == 1">6</span>
				<span v-if = "getPrintPage.zhdx == 1">7</span> 逻辑推理脑网络图</h6>
			<div class="six-res">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.2.2六六脑解读</a>
				<a v-if="luojituili.status == 1 && getshuzibijiao.status == 0  && singleReport.status == 0">1.1.2六六脑解读</a>
				<a v-if="luojituili.status == 1 && getshuzibijiao.status == 1 && singleReport.status == 0 && singleReport.status == 0">1.2.2 六六脑解读</a>
			</div>
			<h6 class="nao-effec">逻辑推理与脑效率、脑健康</h6>
			<div class="nao-hel">
				<p>{{luojituili.efficiency}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic3"></a>
			</div>
		</div>
		<!-- 影响逻辑推理的因素 -->
		<div class="printing" v-if="luojituili.status == 1">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<h6 class="carried-out">影响逻辑推理的因素</h6>
			<div class="carried-sport">
				<p>
					深刻理解与灵活运用基础知识的能力、想象力、语言能力、情绪状态、脑疲劳或脑损伤、脑发育不良等是逻辑推理的影响因素。逻辑推理需要雄厚的知识积累，这样才能为每一步推理提供充分的依据。例如“为什么乱切的萝卜比切得整齐规则的萝卜更好煮烂、口味更好？”这个问题对一个初中生来说不知道该如何回答，而他的母亲却解释得很好。显然是因为母亲对日常生活知识的理解运用要远远强于中学生。因此，深刻理解与灵活运用基础知识的能力是个体逻辑推理能力的基础。逻辑推理有较强的灵活性和开发性，发挥想象对逻辑推理能力的提高有很大的促进作用。从多角度观察认识事物，全面地认识事物的内部与外部之间、某事物同其他事物之间的多种多样的联系，拓展自己的想象力。语言能力的好坏不仅直接影响想象力的发展，而且逻辑推理依赖于严谨的语言表达和正确的书面表达。因此，重视个体的语言培养，尤其是数学语言和几何语言的培养对个体逻辑推理能力的形成是不可或缺的关键一环。心理学研究揭示，不良的情绪会影响逻辑推理的速度和准确程度。暴怒与痛哭，持续的忧郁、烦恼与恐惧，都会对推理产生不良影响。所以，个体保持平静、轻松的情绪对逻辑推理有着重要的作用。此外，逻辑推理能力高低是由背外侧前额叶皮层、顶叶、前扣带皮层和特定的颞顶叶皮层区域的沟通效率所导致的。脑疲劳或脑损伤、脑发育不良等会引起神经活动的异常，损伤大脑皮层功能和结构，造成逻辑推理能力的不好。
				</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic4"></a>
			</div>
		</div>
		<!-- 逻辑推理 提升方案 -->
		<div class="printing" v-if="luojituili.status == 1">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="play-adv">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "luojituili.brainEfficiency == '良好' || luojituili.brainEfficiency == '中等' ||luojituili.brainEfficiency == '欠佳'">
					<a v-if = "getPrintPage.zhdx == 1">2.2.3 提升方案</a>
					<a v-if="luojituili.status == 1 && getshuzibijiao.status == 0  && singleReport.status == 0">1.1.3提升方案</a>
					<a v-if="luojituili.status == 1 && getshuzibijiao.status == 1  && singleReport.status == 0">1.2.3提升方案</a>
					</a>
					<a v-if = "luojituili.brainEfficiency == '出色' ">
					<a v-if = "getPrintPage.zhdx == 1">2.2.3如何发挥优势？</a>
					<a v-if="luojituili.status == 1 && getshuzibijiao.status == 0  && singleReport.status == 0">1.1.3如何发挥优势？</a>
					<a v-if="luojituili.status == 1 && getshuzibijiao.status == 1  && singleReport.status == 0">1.2.3如何发挥优势？</a>
					</a>
					</a>
			</div>
			<p class="Suggest">{{luojituili.advice}}</p>
			<div class="sport-table">
				<table v-if = "this.tuxintuiliList.length<=4">
					<tr v-for = "(item,index) in tuxintuiliList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
				<table v-if = "this.tuxintuiliList.length>4">
					<tr v-for = "(item,index) in luojituiliList1">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic5"></a>
			</div>
		</div>
		<!-- 逻辑推理提升表格2 -->
		<div class="printing" v-if = "this.tuxintuiliList.length>4">
			<h2 class="printing-header"  v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="luojituili.status == 1 &&　singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in luojituiliList2">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num graphic5"></a>
			</div>
		</div>
		<!-- 单项解读 加工速度 -->
		<div class="printing" v-if="jagongsport.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="jagongsport.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="printing-left" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/speed.png" alt="图片" />
			</div>
			<div class="printing-left" 
			v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">
				<img src="../assets/jiagong-two.png" alt="图片" />
			</div>
			<div class="printing-left" 
			v-if = "jagongsport.status == 1 && singleReport.status == 0 &&luojituili.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">
				<img src="../assets/jia-one.png" alt="图片" />
			</div>
			
			<div class="scene-intr" v-if = "jagongsport.isboy == 0">
				<p>加工速度（Processing speed）是指人脑对信息的获取、存储、加工和使用的过程所需的时间。它实质上反应了认知过程的内部心理机制的变化过程。</p>
			</div>
			<div class="scene-intr" v-if = "jagongsport.isboy == 1">
				<p>加工速度（Processing speed）是指个体吸收信息、处理信息、记忆信息和提取信息的快慢。加工速度主要涉及的脑网络是感觉运动网络（包括中央前回和中央后回等脑区）和注意网络（包含后顶叶等脑区）。它实质上反应了认知过程的内部心理机制的变化过程。例如，在接触新事物和学习新知识时，加工速度好的人，能很快适应新事物，找到学习的关键点，给人以“聪明灵敏”的感觉。数字符号转换 （Digital Symbol Substitution）选自韦氏智力测验的分测验（Wechsler, 1958），通过计算数字和特殊符号匹配的反应时和正确率来检测个体的速度，被广泛地用于个体加工速度的评估。该范式被广泛地应用于很多神经心理测验中作为评估个体心理发展水平的重要工具。</p>
			</div>
			<div class="play-adv" style="margin-top:0.33rem">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.3.1 检测结果</a>
				<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">1.2.1 检测结果</a>
				<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&luojituili.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">1.1.1 检测结果</a>
			</div>
			<div class="Detection-res"  v-if = "jagongsport.isboy == 0">
				<p>通过各项指标计算，您的加工速度得分为<span>{{jagongsport.score}}</span>，超过所处年龄段<span>{{jagongsport.agegroup}}</span><span>{{jagongsport.exceed}}</span>%的人，您的此项脑功能<span>{{jagongsport.brainHealth}}</span>，脑效率处<span>{{jagongsport.brainEfficiency}}</span>水平。</p>
				<p>大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回，中央后回、后顶叶等。根据您在数字符号转换任务中的成绩可推测出您加工速度脑网络<span>{{jagongsport.brainEfficiency}}</span>。如图6。</p>
			</div>
			<div class="Detection-res"  v-if = "jagongsport.isboy == 1">
				<p>在数字符号转换任务中，孩子在一定时间内答对测试题目的个数越多，即孩子反应速度越快，得分越高，在反应时上的具体表现如表1。通过各项指标计算，您的孩子加工速度得分为<span>{{jagongsport.score}}</span>，超过所处年龄段<span>{{jagongsport.agegroup}}</span><span>{{jagongsport.exceed}}</span>%的人，孩子的此项脑功能<span>{{jagongsport.brainHealth}}</span>，脑效率处<span>{{jagongsport.brainEfficiency}}</span>水平.</p>
				<p>大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回、中央后回、后顶叶等。这些脑区以及它们之间的功能和结构连接被科学家们称作感觉运动网络和注意网络。根据您孩子在数字符号转换任务中的成绩可推测出孩子加工速度脑网络状态<span>{{jagongsport.brainEfficiency}}</span>。如图
				<span v-if = "getshuzibijiao.status == 0  && singleReport.status == 0 && qinjingjiyi.status == 0 && luojituili.status == 0 && jagongsport.status == 1">1</span><!-- 唯一加工 -->
				<span v-if = "getPrintPage.zhdx == 1 &&getshuzibijiao.status == 1  && qinjingjiyi.status == 1 && jagongsport.status == 1">6</span><!-- 大人 综合-->
				<span v-if = "getPrintPage.zhdx == 1 &&getshuzibijiao.status == 1  && luojituili.status == 1 && jagongsport.status == 1">8</span> <!-- 儿童 综合-->
				<span v-if = "singleReport.status == 0 &&getshuzibijiao.status == 1  && jagongsport.status == 1">4</span> <!-- 单项 有数字比较-->
				<span v-if = "singleReport.status == 0 &&qinjingjiyi.status == 1 && jagongsport.status == 1">2</span> <!-- 单项 有情景记忆-->
				<span v-if = "singleReport.status == 0 &&luojituili.status == 1 && jagongsport.status == 1">4</span> <!-- 单项 有逻辑推理-->。
				</p>
			</div>
			<div class="nao-memory">
				<img v-if="jagongsport.cid == 4" src="../assets/naoj-1.png" alt="图片" />
				<img v-if="jagongsport.cid == 3" src="../assets/naoj-2.png" alt="图片" />
				<img v-if="jagongsport.cid == 2" src="../assets/naoj-3.png" alt="图片" />
				<img v-if="jagongsport.cid == 1" src="../assets/naoj-4.png" alt="图片" />
			</div>
			<h6 class="nao-memory-bot">图
				<span v-if = "getshuzibijiao.status == 0  && singleReport.status == 0 && qinjingjiyi.status == 0 && luojituili.status == 0 && jagongsport.status == 1">1</span><!-- 唯一加工 -->
				<span v-if = "getPrintPage.zhdx == 1 &&getshuzibijiao.status == 1  && qinjingjiyi.status == 1 && jagongsport.status == 1">6</span><!-- 大人 综合-->
				<span v-if = "getPrintPage.zhdx == 1 &&getshuzibijiao.status == 1  && luojituili.status == 1 && jagongsport.status == 1">8</span> <!-- 儿童 综合-->
				<span v-if = "singleReport.status == 0 &&getshuzibijiao.status == 1  && jagongsport.status == 1">4</span> <!-- 单项 有数字比较-->
				<span v-if = "singleReport.status == 0 &&qinjingjiyi.status == 1 && jagongsport.status == 1">2</span> <!-- 单项 有情景记忆-->
				<span v-if = "singleReport.status == 0 &&luojituili.status == 1 && jagongsport.status == 1">4</span> <!-- 单项 有逻辑推理-->
				加工速度脑网络图</h6>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num processing1"></a>
			</div>
		</div>
		<!-- 单项解读j加工速度 2.3.2 脑图 -->
		<div class="printing" v-if="jagongsport.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="jagongsport.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="enhance-pro">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "getPrintPage.zhdx == 1">2.3.2 六六脑解读</a>
				<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">1.2.2 六六脑解读</a>
				<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&luojituili.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">1.1.2 六六脑解读</a>
			</div>
			<h6 class="nao-enhance">加工速度与脑效率、脑健康</h6>
			<div class="memory-error">
				<p>{{jagongsport.efficiency}}</p>
			</div>
			<h6 class="factor">影响加工速度的因素</h6>
			<div class="age-factor" v-if = "jagongsport.isboy == 1">
				<p>神经脉冲速度、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份作业，孩子感兴趣的作业，投入的注意力更集中，做的效率会更高。</p>
			</div>
			<div class="age-factor"  v-if = "jagongsport.isboy == 0">
				<p>神经脉冲速度（生理因素）、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份工作，您感兴趣的工作，投入的注意力更集中，做的效率会更高。</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num processing2"></a>
			</div>
		</div>
		<!-- 单项解读加工速度2.3.3 提升方案 -->
		<div class="printing" v-if="jagongsport.status == 1">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="jagongsport.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="play-adv">
				<img src="../assets/jiantou.png" alt="图片" />
				<a v-if = "jagongsport.brainEfficiency == '良好' || jagongsport.brainEfficiency == '中等' ||jagongsport.brainEfficiency == '欠佳'">
					<a v-if = "getPrintPage.zhdx == 1">2.3.3 提升方案</a>
					<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">1.2.3 提升方案</a>
					<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&luojituili.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">1.1.3 提升方案</a>
					</a>
					<a v-if = "jagongsport.brainEfficiency == '出色'">
					<a v-if = "getPrintPage.zhdx == 1">2.3.3如何发挥优势？</a>
					<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&(luojituili.status == 1|| qinjingjiyi.status == 1 || getshuzibijiao.status == 1)">1.2.3 如何发挥优势？</a>
					<a v-if = "jagongsport.status == 1 && singleReport.status == 0 &&luojituili.status == 0 && qinjingjiyi.status == 0 && getshuzibijiao.status == 0">1.1.3 如何发挥优势？</a>
					</a>
					</a>
			</div>
				<p class="Suggest">{{jagongsport.advice}}</p>
			<div class="sanjaio-bot"></div>
			<div class="sport-table">
				<table v-if = "this.jiagongsuduList.length<=4">
					<tr v-for ="(item,index) in jiagongsuduList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
				<table v-if = "this.jiagongsuduList.length>4">
					<tr v-for ="(item,index) in jiagongsuduList1">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num processing3"></a>
			</div>
		</div>
		<!-- 单项解读加工速度2.3.3 提升方案 -->
		<div class="printing" v-if = "this.jiagongsuduList.length>4">
			<h2 class="printing-header" v-if = "getPrintPage.zhdx == 1">
				<img src="../assets/even-map.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if="jagongsport.status == 1 && singleReport.status == 0">
				<img src="../assets/danxiag-one.png" alt="图片" />
			</h2>
			<div class="sport-table">
				<table>
					<tr v-for ="(item,index) in jiagongsuduList2">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num processing3"></a>
			</div>
		</div>
		<!-- 您知道吗 -->
		<div class="printing">
			<h2 class="printing-header" v-if="getPrintPage.zhdx == 1">
				<img src="../assets/you-know.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "singleReport.status == 0">
				<img src="../assets/youknow-two.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
			<img v-if="getTalentyou.id == 1" src="../assets/memory-talent.png">
			<img v-if="getTalentyou.id == 2" src="../assets/luoji-talent.png">
			<img v-if="getTalentyou.id == 3" src="../assets/linhuo-talent.png">
			<img v-if="getTalentyou.id == 4" src="../assets/yanyu-talent.png">
			</h3>
			<div class="memory-img">
				<img :src="getTalentyou.userUrl" alt="图片" />
			</div>
			<div class="age-factor">
				<p>{{getTalentyou.introduction}}</p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num know"></a>
			</div>
		</div>
		<!-- 后记 -->
		<div class="printing">
			<h2 class="printing-header" v-if="getPrintPage.zhdx == 1">
				<img src="../assets/postscript.png" alt="图片"/>
			</h2>
			<h2 class="printing-header" v-if="singleReport.status == 0">
				<img src="../assets/houji-two.png" alt="图片"/>
			</h2>
			<div class="Follow-up" v-if = "getPrintPageFirst.isboy == 0">
				<p>1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价您的脑功能，但科学检测是深入了解脑功能的一扇门。</p>
				<p>2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使您的结果更真实。</p>
				<p>3、本检测主要用于评估您的基础脑功能，如果您想用于评价个人能力和职业发展，建议结合职业、性格等测试。此外，越全面的脑功能用于评价个人能力和职业发展的效度越高。</p>
			</div>
			<div class="Follow-up" v-if = "getPrintPageFirst.isboy == 1">
				<p>1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。</p>
				<p>2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。</p>
				<p>3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。</p>
				<p>4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。</p>
			</div>
			<div class="QR-code">
				<img src="../assets/QR-code.jpg" alt="六六脑官方微信">
				<p class="QR-we">六六脑官方微信</p>
				<!-- <p class="QR-we" style="font-weight:bolder">扫描二维码申请试用脑功能训练</p> -->
				<p class="QR-we" style="font-weight:bolder">更多脑能力测评请登录<a  target="_Blank" href="http://cp.66nao.com">cp.66nao.com</a></p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num postscript"></a>
			</div>
		</div>
		<a href="javascript:;" class="closePrint" title="打印" @click = "print_page()" ></a>
		<a href="javascript:;" class="closePage" title="关闭" @click = "print_close()"></a>
		<a href="javascript:;" class="moveUp" title="回到顶部"></a>
	</div>
</template>
<style lang="scss">
	@import "../styles/core/reset.scss";
	@page {
		size: auto A4 landscape;
		margin: 0mm;
	}
	.printing-wrap {
		.printing {
			position: relative;
			width: 12.40rem;
			height: 16.68rem;
			background: #fff;
			margin: 0 auto 0.1rem;
			page-break-after: always;
			.overall-con {
				height: 12.64rem;
				text-align: center;
			}
			.report-corver {
				height: 0.49rem;
				line-height: 0.49rem;
				padding-top: 1.70rem;
				width: 2.50rem;
				margin: 0 auto;
			}
			.report-dete {
				width: 5.04rem;
				height: 3.05rem;
				margin: 0 auto;
				margin-top: .45rem;
			}
			.report-naologo {
				width: 7.14rem;
				height: 5.50rem;
				margin: 0 auto;
				img {
					margin-top: 0.44rem;
				}
			}
			.QR-code {
				position: absolute;
				bottom: 2rem;
				right: 40%;
				img{
					width: 2rem;
					height: 2rem;
					margin-left: 18%;
				}
				.QR-we{
					text-align: center;
					font-size: 0.22rem;
					padding-bottom:0.12rem;
					a{
					  color: rgb(68, 154, 208);
		              text-decoration: underline;
		              font-weight: 400;
		              cursor: pointer;
		              padding-left: 0.05rem;
					}
				}
			}
			.report-age-sex {
				width: 4.36rem;
				font-size: 32px;
				color: #000000;
				line-height: 59px;
				margin: 0 auto;
				margin-top: 1.31rem;
				@include flexbox;
				ul {
					padding-right: 0.28rem;
					width: 0.96rem;
					font-weight: bold;
				}
				div {
					@include flex;
					p{
						width: 3.10rem;
						height: 0.59rem;
						text-align: center;
						border-bottom: 1px solid #000000;
					}
				}
			}
			.report-mumber {
				margin: 0 auto;
				height: 0.33rem;
				line-height: 0.33rem;
				text-align: center;
				margin-top: 1.06rem;
				padding-bottom: 0.4rem;
				p {
					font-family: PingFangTC-Semibold;
					font-size: 24px;
					color: #444444;
				}
			}
			.printing-header {
				width: 10.40rem;
				height: 0.9rem;
				padding-top: 0.95rem;
				margin-bottom: 0.8rem;
				img {
					margin: 0 1rem;
				}
			}
			.toc-mulu{
				width: 10.40rem;
				margin:0 auto 0.2rem;
				position: relative;
					span {
							font-size: 0.28rem;
							position: absolute;
							right: 0;
						}
					.dast-xian {
						margin-left: 0.22rem;
					}
				.title-prin {
					h6{
						height: 0.33rem;
						line-height: 0.33rem;
						color: #444444;
						font-size: 0.32rem;
						font-family: PingFangTC-Semibold;
					}
				}
				.title-prin-two{
					margin-top: 0.32rem;
					li{
						padding-bottom: 0.26rem;
					}
					p{
						height: 0.26rem;
						line-height: 0.26rem;
						color: #444444;
						font-size: 0.24rem;
						font-family: PingFangTC-Semibold;
						margin-left:0.20rem;
					}
				}
				.Single{
					margin-top:0.2rem;
				}
				.zhixing{
					margin-left: 0.18rem;
				}
				.know-now{
					margin-top:0.42rem;
					margin-bottom: 0.42rem;
				}
				.last{
					margin-top: 0.66rem;
				}
				.zhixing-small{
					margin-top: 0.32rem;
					p{
						height: 0.22rem;
						line-height: 0.22rem;
						font-size: 0.24rem;
						font-weight: bold;
						margin-left:0.20rem;
						font-family: PingFangTC-Semibold;
					}
				}
			}
			.interesting{
				height: 0.26rem;
				line-height: 0.26rem;
				color: #444444;
				font-size: 0.24rem;
				font-family: PingFangTC-Semibold;
				margin-left:0.20rem;
			}
			.printing-left {
				height: 0.6rem;
				margin: 0 auto 0.4rem;
				img {
					height: 0.6rem;
				}
			}
			.score-Introduction {
				width: 10.40rem;
				margin: 0 auto;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem;
			}
			.table-title {
				margin: 0.40rem auto 0.20rem;
				font-size: 24px;
				color: #333333;
				height: 0.33rem;
				line-height: 0.33rem;
				text-align: center;
			}
			.read-table {
				width: 10.16rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					th {
						background: #DBDBDB;
						width: 2.54rem;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;
						border: 1px solid #DDDDDD;
					}
					th:nth-last-child(1) {
						border-right: none;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
						white-space: nowrap;
					}
					.numjia{
						vertical-align:super;
					}
				}
			}
			.printing-table {
				width: 10.16rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					th {
						background: #DBDBDB;
						width: 1.01rem;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					th:nth-last-child(1) {
						border-right: none;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;   
						border: 1px solid #DDDDDD;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
						white-space: nowrap;
						&.red{
							color: red;
						}
						&.blue{
							color: blue;
						}
					}
				}
			}
			.coefficient-Interpretation {
				width: 10.40rem;
				margin: 0.32rem auto 0.60rem;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem;
				b {
					color: #000000;
				}
			}
			.printing-map {
				height: 0.6rem;
				margin: 0 auto;
				img {
					height: 0.6rem;
				}
			}
			.brain-bot {
				width: 10.40rem;
				margin: 0.40rem auto 0.62rem;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem
			}
			.echart-barin {
				width: 3.68rem;
				height: 3.68rem;
				margin: 0 auto;  
				text-align: center;
				#radarChart {
					width: 3.68rem;
					height: 3.68rem; 
				}
			}
			.brain-img-bot {
				height: 0.33rem;
				margin: 0.75rem auto 0.38rem;
				font-size: 24px;
				color: #333333;
				line-height: 33px;
				text-align: center;
				font-weight: bolder;
			}
			.map-inter {
				width: 10.40rem;
				margin: 0 auto 0.60rem;
				p {
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
					padding-bottom: 0.15rem;
				}
			}
			.Synthesis-mind {
				width: 10.40rem;
				margin: 0.4rem auto 0.06rem;
				p {
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
					padding-bottom: 0.15rem;
				}
			}
			.Summarized {
				width: 10.40rem;
				margin: 0 auto 0.60rem;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.Summarized-Features {
				height: 0.6rem;
				margin: 0.60rem auto 0.4rem;
				img {
					height: 0.6rem;
				}
			}
			.Summarized-fea {
				width: 10.40rem;
				margin: 0 auto 0.27rem;
				p {
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
					padding-bottom: 0.15rem;
				}
			}
			.Summarized-res {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				img {
					padding: 0;
					border: 0;
					padding: 0 0.1rem 0.1rem 0;
				}
				a {
					font-size: 28px;
					color: #444444;
					height: 0.3rem;
					line-height: 0.3rem;
				}
			}
			.Summarized-Synthesis {
				width: 10.40rem;
				margin: 0.64rem auto 0.01rem;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.Rating-table {
				width: 10.14rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					border: 1px solid #DDDDDD;
					th {
						background: #DBDBDB;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					th:nth-child(1) {
						width: 1.50rem;
					}
					th:nth-child(2) {
						width: 4.83rem;
					}
					th:nth-child(3) {
						width: 3.77rem;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;
						border:1px solid #979797;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
					}
				}
			}
			.Rating-table-luoji{
				width: 10.14rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					border: 1px solid #DDDDDD;
					th {
						background: #DBDBDB;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					th:nth-child(1) {
						width: 1.50rem;
					}
					th:nth-child(2) {
						width: 2.87rem;
					}
					th:nth-child(3) {
						width: 2.87rem;
					}
					th:nth-child(4) {
						width: 2.87rem;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;
						border:1px solid #979797;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
					}
				}
			}
			.tableindex {
				width: 10.40rem;
				margin: 0.3rem auto 0;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.echart-performed-one {
				width: 10.40rem;
				margin: 0 auto 0.26rem;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.echart-reaction-one {
				width: 7rem;
				height: 4.5rem;
				margin: 0 auto;
			}
			.echart-performed-two {
				width: 10.40rem;
				margin: 0.6rem auto 0.6rem;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.difficulty {
				p{
					transform: rotate(-360deg);
					font-family: PingFangTC-Semibold;
					font-size: 20px;
					color: #444444;
					text-align: center;
					margin-top: 0.16rem;
					margin-bottom:0.3rem;
				}
				h6{
					font-family: PingFangTC-Semibold;
					font-size: 24px;
					color: #333333;
					line-height: 33px;
					text-align: center;
				}
			}
			.echart-reaction-two {
				width: 7rem;
				height: 4.5rem;
				margin: 0 auto;
			}
			.nerve {
				width: 10.40rem;
				margin: 0 auto;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
				}
			}
			.brain-figure {
				width: 5rem;
				height: 5rem;
				margin: 0 auto;
			}
			.brain-des {
				text-align: center;
				font-size: 24px;
				color: #333333;
				line-height: 33px;
			}
			.six-res {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				img {
					padding: 0;
					border: 0;
					margin: 0 0.1rem 0.1rem  0;
				}
				a {
					font-size: 28px;
					color: #444444;
					height: 0.3rem;
					line-height: 0.3rem;
				}
			}
			.nao-effec {
				font-size: 24px;
				color: #444444;
				line-height: 33px;
				margin: 0.5rem 0 0.2rem 1rem;
			}
			.nao-hel {
				width: 10.40rem;
				margin: 0 auto;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
				}
			}
			.carried-out {
				margin: 0.6rem 0 0.2rem 1rem;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.carried-sport {
				width: 10.40rem;
				margin: 0 auto;
				p {
					text-indent: 0.48rem;
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
				}
			}
			.carried-out-page {
				width: 10.40rem;
				margin: 0 auto 0;
				p {
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
				}
			}
			.enhance-pro {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				img {
					padding: 0;
					border: 0;
				    padding:0 0.1rem 0.1rem 0; 
				}
				a {
					font-size: 28px;
					color: #444444;
					height: 0.3rem;
					line-height: 0.3rem;
				}
			}
			.Suggest {
				margin: 0.6rem 1rem 0.31rem 1rem;
				font-family: PingFangTC-Regular;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.sport-table {
				width: 10.40rem;
				margin: 0 auto;
				table {
					margin-bottom: 0.4rem;
					border: 1px solid #979797;
					tr {
						box-sizing: border-box;
						text-align: center;
						line-height: 33px;
					}
					td {
						border-right: 1px solid #979797;
						border-top: 1px solid #979797;
					}
					td:nth-child(1) {
						width: 3.14rem;
						font-size: 24px;
						color: #444444;
						line-height: 33px;
						background: #DFF4F8;
						padding-left: 0.3rem;
						padding-right: 0.3rem;
					}
					td:nth-child(2) {
						width: 7.26rem;
						font-size: 20px;
						color: #444444;
						line-height: 33px;
						padding: 0.38rem 0.46rem 0.37rem 0.4rem;
						text-indent: 48px;
						text-align: left;
					}
				}
			}
			.scene-intr {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.scene-res {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				margin-top: 0.33rem;
				img {
					padding: 0;
					border: 0;
					padding:0 0.1rem 0.1rem 0;
				}
				a {
					font-size: 28px;
					color: #444444;
					height: 0.3rem;
					line-height: 0.3rem;
				}
			}
			.Detection-res {
				width: 10.40rem;
				margin: 0.61rem auto 0;
				p:nth-child(1) {
					padding-bottom: 0.1rem;
				}
				p {
					font-family: PingFangTC-Regular;
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.Detection-table {
				width: 10.16rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					border: 1px solid #999999;
					th {
						background: #DBDBDB;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border: 1px solid #DDDDDD;
						border-right: 1px solid #979797;
					}
					th:nth-last-child(1) {
						border-right: none;
					}
					th:nth-child(1) {
						width: 1.50rem;
					}
					th:nth-child(2) {
						width: 3.25rem;
					}
					th:nth-child(3) {
						width: 1.52rem;
					}
					th:nth-child(4) {
						width: 1.52rem;
					}
					th:nth-child(5) {
						width: 2.24rem;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;
					}
					td {
						border-right: 1px solid #979797;
						border-top: 1px solid #979797;
					}
					.rowspan-td {
						background: #FDFDFF;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					.bordernone-right {
						border-right: none !important;
					}
				}
			}
			.nerv-show {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.nao-memory {
				width: 5rem;
				height: 5rem;
				margin: 0 auto;
			}
			.nao-memory-bot {
				text-align: center;
				font-size: 24px;
				color: #333333;
				line-height: 33px;
			}
			.nao-enhance {
				margin: 0.6rem 0 0.21rem 1rem;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.memory-error {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.factor {
				margin: 0.61rem 0 0.24rem 1rem;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.age-factor {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.play-adv {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				img {
					padding: 0;
					border: 0;
					padding:0 0.1rem 0.1rem 0;
				}
				a {
					font-size: 28px;
					color: #444444;
					height: 0.3rem;
					line-height: 0.3rem;
				}
			}
			.outstanding {
				width: 10.24rem;
				margin: 0.6rem auto 0.51rem;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.sanjaio-bot {
				height: 0.33rem;
				line-height: 0.33rem;
				margin-left: 1rem;
				margin-top: 0.30rem;
			}
			.memory-img {
				height: 6.34rem;
				width: 4.82rem;
				margin: 0.8rem auto 0.6rem;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.Follow-up {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
					margin-bottom: 0.1rem;
				}
			}
			.read-guid {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
					margin-bottom: 0.60rem;
				}
			}
			.read-prin {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
				.read-prin-bot {
					margin-bottom: 0.1rem;
				}
			}
			.sore-table-title {
				font-size: 24px;
				color: #333333;
				line-height: 33px;
				text-align: center;
				margin-top: 0.4rem;
				margin-bottom: 0.2rem;
			}
			.read-table-bot {
				width: 10.40rem;
				margin: 0.30rem auto 0;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.page-Increment {
				position: absolute;
				bottom: 0.26rem;
				right: 1rem;
				.page-size {
					font-size: 14px;
					color: #000000;
				}
				.page-img {
					font-size: 11px;
					color: #FFFFFF;
				}
				.page-num {
					font-size: 20px;
					color: #000000;
				}
			}
		}
		.closePrint{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: block;
			bottom:190px;
			background: url(../assets/printM.png)  no-repeat left top;
			margin-left: 660px;
		}
		.closePrint:hover{
			background: url(../assets/printHover.png)  no-repeat left top;
		}
		.closePage{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: block;
			bottom:120px;
			background: url(../assets/closeM.png)  no-repeat left top;
			margin-left: 660px;
		}
		.closePage:hover{
			background: url(../assets/closeHover.png)  no-repeat left top;
		}
		.moveUp{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: none;
			bottom:50px;
			background: url(../assets/moveUp.png)  no-repeat left top;
			margin-left: 660px;
		}
		.moveUp:hover{
			background: url(../assets/moveHover.png)  no-repeat left top;
		}
	}
</style>
<script>
	// 引入基本模板
	let echarts = require('echarts/lib/echarts')
	// 引入柱状图组件
	require('echarts/lib/chart/bar')
	// 引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	export default {
		data() {
				return {
					// 首页
					getPrintPageFirst: {},//报告单首页信息
					getPrintPage: {},//判断综合
					singleReport:{},//单项脑功能解读的status
					getscoreList: {},//游戏参数解读 
					brainsuggest: {},//脑功能综合解读建议预警
					radarList: {},//雷达图参数
					Reactiontime: {},//数字比较反应时柱状图
					Correctrate: {},//数字比较正确率的柱状图
					ReactTu: {},//图形推理反应时柱状图
					Reactxing:{},//图形推理正确率柱状图
					getshuzibijiao: {},//单项解读数字比较
					getrenwuqingjing: {},//单项人物情景解读
					getTalentyou: {},//您知道吗？
					jagongsport: {},//单项解读数字符号转换
					qinjingjiyi: {},//情景记忆单项解读
					luojituili: {},//逻辑推理单项解读
					shuzibijiaoList :{},//数字比较列表
					tuxintuiliList :{},//图形推理列表
					tuxintuiliList1 :{},//图形推理列表
					tuxintuiliList2 :{},//图形推理列表
					jiagongsuduList:{},//加工速度列表
					renwuqingjign:{},//情景记忆提升表格
				}
			},
			mounted() {
				// 综合解读
				 var token = localStorage.getItem('token')
				this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
				// token: localStorage.getItem('admintoken') == null?localStorage.getItem('token'):localStorage.getItem('admintoken'),
				token:token,
				eid: localStorage.getItem('eid')
				}).then(function(res) {
					this.getPrintPage = res.body//报告单首页信息
					this.getscoreList = res.body.resultBos;//游戏参数解读 
					this.brainsuggest =res.body.brainAtlas;//脑功能综合解读建议预警
					this.$nextTick(function(){
						if(this.getPrintPage.zhdx == 1){
							this.drawLine();//雷达图
						}
					})
				})
				// 单向解读
				 var token = localStorage.getItem('token')
				this.$http.post(urls.urlReport + '/game/individual.json', {
					token:token,
				eid: localStorage.getItem('eid')
				}).then(function(res) {
					console.log(res.body)
					this.singleReport  = res.body//单项报告status
					this.getshuzibijiao = res.body.szbjResult//单项解读数字比较
					this.getrenwuqingjing = res.body.szbjResult//单项人物情景解读
					this.jagongsport = res.body.fhzhResult//符号转换
					this.qinjingjiyi = res.body.rwqjResult//情景记忆
					this.luojituili =  res.body.txtlResult//逻辑推理
					this.shuzibijiaoList = res.body.szbjResult.list//数字比较的提升表格
					this.tuxintuiliList = res.body.txtlResult.list//图形推理的提升表格
					this.jiagongsuduList = res.body.fhzhResult.list//符号转换提升表格
					this.renwuqingjign = res.body.rwqjResult.list//情景记忆提升表格
					if(this.tuxintuiliList.length> 4){
						console.log(this.tuxintuiliList)
						var luojituiliList1 = [];
						var luojituiliList2 =[];
						luojituiliList2.push(this.tuxintuiliList[this.tuxintuiliList.length-1])
						for( var i=0;i<this.tuxintuiliList.length-1;i++){
							luojituiliList1.push(this.tuxintuiliList[i])
						}
						this.luojituiliList1 = luojituiliList1;
						this.luojituiliList2 = luojituiliList2;
					}
					if(this.jiagongsuduList.length> 4){
						console.log(this.tuxintuiliList)
						var jiagongsuduList1 = [];
						var jiagongsuduList2 =[];
						jiagongsuduList2.push(this.jiagongsuduList[this.jiagongsuduList.length-1])
						for( var i=0;i<this.jiagongsuduList.length-1;i++){
							luojituiliList1.push(this.jiagongsuduList[i])
						}
						this.jiagongsuduList1 = jiagongsuduList1;
						this.jiagongsuduList2 = jiagongsuduList2;
					}
					this.$nextTick(function(){
						if(this.getshuzibijiao.status == 1){
							this.drawarea();//数字比较的反应时柱状图
							this.drawRight();//数字比较的正确率的柱状图
						}
						if(this.luojituili.status == 1){
							this.drawGraphics();//图形推理的反应时柱状图
							this.drawRae();//图形推理的正确率柱状图
						}
					})
				})
				this.addDiv();
					var timer = null;
					var isTop = true;
					var clientHeight = document.documentElement.clientHeight;
					// 滚动条滚动中触发
					window.onscroll = function(){
						var osTop = document.documentElement.scrollTop || document.body.scrollTop;
						if(osTop >= clientHeight){
							$('.moveUp').css('display','block')
						}else{
							$('.moveUp').css('display','none')
						}
						if(!isTop){
							clearInterval(timer)
						}
						isTop = false;
					}
					
					$('.moveUp').click(function(){
						timer = setInterval(function(){
							//当前屏幕的滚动的高度具体顶部的高度
							var osTop = document.documentElement.scrollTop || document.body.scrollTop;
							var ispeeed = Math.floor(-osTop/5)
							document.documentElement.scrollTop = document.body.scrollTop = osTop+ispeeed;	
							// console.log( osTop+ispeeed)
							isTop = true;
							if (osTop == 0) {
								clearInterval(timer)
							}
						},30)
					})
			},
			methods: {
				// 雷达图
				drawLine() {
					//雷达图
					 var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
					   token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						this.radarList = res.body.brainAtlas.atlas;//雷达图参数
						console.log(res.body.status)
						// console.log(document.getElementById('radarChart'))
						let myChart = this.$echarts.init(document.getElementById('radarChart'))
						myChart.setOption({
							radar: {
								indicator: [{
									text: '逻辑型',
									max: 100
								}, {
									text: '语言型',
									max: 100
								}, {
									text: '记忆型',
									max: 100
								}, {
									text: '灵活型',
									max: 100
								}],
								nameGap: 4, // 图中工艺等字距离图的距离
								center: ['50%', '50%'],
								radius: '80%',
								// startAngle: 45,
								startAngle: 90,
								splitNumber: 3,
								shape: 'circle',
								name: {
									show: true, // 是否显示工艺等文字
									formatter: null, // 文字的显示形式
									textStyle: {
										color: '#000000' //文字的颜色
									},
									axisLine: {}
								},
								splitArea: {
									areaStyle: {
										color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'] //每一个区域的颜色
									}
								},
								axisTick: {
									show: true,
									lineStyle: {
										color: 'rgba(255, 255, 255, 0.8)' //未知
									}
								},

								axisLine: {
									lineStyle: {
										color: 'rgba((255, 255, 255, 0.4)' //十字架的颜色
									}
								},
								splitLine: {
									lineStyle: {
										color: '#DDDDDD' //外圈的颜色
									}
								},
							},
							series: [{
								type: 'radar',
							    symbol: "none", // 去掉图表中各个图区域的边框线拐点
								tooltip: {
									trigger: 'item'
								},
								itemStyle: {
									normal: {
										areaStyle: {
											color:'#5089F4'//背景填充色
										},
										lineStyle: {
		                                    color:"#5089F4" // 图表中各个图区域的边框线颜色
		                                },
									},
								},
								data: [{
									value: [this.radarList[0], this.radarList[1], this.radarList[2], this.radarList[3]],
									name: '雷达图'
								}]
							}]
						});
					})
				},
				// 反应时柱状图
				drawarea() {
					// 反应时图表
						 var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/game/szbjIndivdual.json', {
					   token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						console.log(res.body)
						this.Reactiontime = res.body;
						this.ReactiontimeRate =  res.body.hard
						// console.log(document.getElementById('histogram'))
						let myChart = echarts.init(document.getElementById('histogram'))
						// let myChart = this.$echarts.init(document.getElementById('histogram'))
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'show'
								}
							},
							grid: {
								left: '6%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							yAxis: {
								axisLabel: {
									formatter: function(value) {
										var texts = [];
										if (value === 5800) {
											texts.push('反应时(ms)');
										}
										return texts;
									},
									rotate: 90, //Y轴文本倾斜
									textStyle: {
										color: '#000000',
										fontSize: '24',
									}
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: false,
								},
								type: 'value',
								splitNumber: 100,
								max: 10000,
							},
							xAxis: {
								axisLabel: {
									textStyle: {
										color: '#000000'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: true,
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								type: 'category',
								data: ['1', '2', '3', '4']
							},
							series: [{
								name: '反应时',
								type: 'bar',
								data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
								barWidth: '24',
								itemStyle: {
									normal: {
										color: '#09BCD9'
									}
								},
							}, {
								name: '反应时',
								type: 'line',
								data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
								symbolSize: 6,
								symbol: 'circle',
								itemStyle: {
									normal: {
										color: "#09BCD9",
										barBorderRadius: 0,
										label: {
											show: true,
											position: "top",
										}
									}
								},
							}]
						});
					})
				},
				//数字比较正确率
				drawRight() {
					 var token = localStorage.getItem('token')
						this.$http.post(urls.urlReport + '/game/szbjIndivduals.json', {
						   token:token,
						eid: localStorage.getItem('eid')
						}).then(function(res) {
							this.Correctrate = res.body;
							this.correctRate = res.body.hard;
							// console.log(document.getElementById('hisRight'))
							let myChart = echarts.init(document.getElementById('hisRight'))
						// let myChart = this.$echarts.init(document.getElementById('hisRight'))
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'show'
								}
							},
							grid: {
								left: '6%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							yAxis: {
								axisLabel: {
									formatter: function(value) {
										var texts = [];
										if (value === 45) {
											texts.push('正确率(%)');
										}
										return texts;
									},
									rotate: 90, //Y轴文本倾斜
									textStyle: {
										color: '#000000',
										fontSize: '24',
									}
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: false,
								},
								type: 'value',
								splitNumber: 1000,
								max: 100,
							},
							xAxis: {
								axisLabel: {
									textStyle: {
										color: '#000000'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: true,
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								type: 'category',
								data: ['1', '2', '3', '4']
							},
							series: [{
								name: '反应时',
								type: 'bar',
								data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
								barWidth: '24',
								itemStyle: {
									normal: {
										color: '#09BCD9'
									}
								},
							}, {
								name: '反应时',
								type: 'line',
								data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
								symbolSize: 6,
								symbol: 'circle',
								itemStyle: {
									normal: {
										color: "#09BCD9",
										barBorderRadius: 0,
										label: {
											show: true,
											position: "top",
										}
									}
								},
							}]
						});
					})
				},
				// 图形推理反应时
				drawGraphics () {
					 var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/game/txtlIndivdual.json', {
					   token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						console.log(res.body)
						this.ReactTu = res.body;
						this.Graphicstuili = res.body.hard
						console.log(this.ReactTu.status)
						// console.log(document.getElementById('Graphics'))
						let myChart = echarts.init(document.getElementById('Graphics'))
						// let myChart = this.$echarts.init(document.getElementById('Graphics'))
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'show'
								}
							},
							grid: {
								left: '6%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							yAxis: {
								axisLabel: {
									formatter: function(value) {
										var texts = [];
										if (value === 28000) {
											texts.push('反应时(ms)');
										}
										return texts;
									},
									rotate: 90, //Y轴文本倾斜
									textStyle: {
										color: '#000000',
										fontSize: '24',
									}
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: false,
								},
								type: 'value',
								splitNumber: 100,
								max: 50000,
							},
							xAxis: {
								axisLabel: {
									textStyle: {
										color: '#000000'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: true,
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								type: 'category',
								data: ['1', '2', '3', '4','5']
							},
							series: [{
								name: '反应时',
								type: 'bar',
								data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3],this.Graphicstuili[4]],
								barWidth: '24',
								itemStyle: {
									normal: {
										color: '#09BCD9'
									}
								},
							}, {
								name: '反应时',
								type: 'line',
								data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3],this.Graphicstuili[4]],
								symbolSize: 6,
								symbol: 'circle',
								itemStyle: {
									normal: {
										color: "#09BCD9",
										barBorderRadius: 0,
										label: {
											show: true,
											position: "top",
										}
									}
								},
							}]
						});
					})
				},
				drawRae () {
					 var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/game/txtlIndivduals.json', {
					   token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						console.log(res.body)
						this.Reactxing = res.body;
						this.Graprea = res.body.hard
						// console.log(document.getElementById('reasoning'))
						let myChart = echarts.init(document.getElementById('reasoning'))
						// let myChart = this.$echarts.init(document.getElementById('reasoning'))
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'show'
								}
							},
							grid: {
								left: '6%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								axisLabel: {
									textStyle: {
										color: '#000000'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: true,
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								type: 'category',
								data: ['1', '2', '3', '4','5']
							},
							yAxis: {
								axisLabel: {
									formatter: function(value) {
										var texts = [];
										if (value === 50) {
											texts.push('正确率(%)');
										}
										return texts;
									},
									rotate: 90, //Y轴文本倾斜
									textStyle: {
										color: '#000000',
										fontSize: '24',
									}
								},
								axisLine: {
									lineStyle: {
										color: '#cccccc'
									}
								},
								axisTick: {
									show: false,
								},
								splitLine: {
									show: false,
								},
								type: 'value',
								splitNumber: 1000,
								max: 100,
							},
							series: [{
								name: '反应时',
								type: 'bar',
								data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3],this.Graprea[4]],
								barWidth: '24',
								itemStyle: {
									normal: {
										color: '#09BCD9'
									}
								},
							}, {
								name: '反应时',
								type: 'line',
								data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3],this.Graprea[4]],
								symbolSize: 6,
								symbol: 'circle',
								itemStyle: {
									normal: {
										color: "#09BCD9",
										barBorderRadius: 0,
										label: {
											show: true,
											position: "top",
										}
									}
								},
							}]
						});
					})
				},
				// 字体颜色
				color(col) {
						if(col == '不健康') return "#FD836A"
			            if(col  ==  '亚健康') return "#5089F4"
						},
				addDiv() {
					setTimeout(function(){
						$(function () {
					       $('.printing').each(function (index, dom) {
					       	var pageindex =  index < 10 ? "0" + index : index;
					           $(dom).find('.page-num').html(pageindex);

					       })
					      	var out1 =  $('.carried1').html();
					      	var out2 =  $('.carried2').html();
					      	var out3 =  $('.carried1').html();
					      	var out4 =  $('.carried3').html();
					      	var out5 =  $('.carried5').html();
					  		var scene1 =  $('.scene1').html();
					  		var scene2 =  $('.scene2').html();
					  		var scene3 =  $('.scene3').html();
					  		var scene4 =  $('.scene4').html();
					  		var processing1 = $('.processing1').html();
					  		var processing2 = $('.processing2').html();
					  		var processing3 = $('.processing3').html();
					  		var know = $('.know').html();
					  		var postscript = $('.postscript').html();
					  		var graphic1 = $('.graphic1').html()
					  		var graphic2 = $('.graphic2').html()
					  		var graphic3 = $('.graphic3').html()
					  		var graphic4 = $('.graphic4').html()
					  		var graphic5 = $('.graphic5').html()
					      	if(out1){
								    $('.out1').html(out1);
								}else if(scene1){
								    $('.out1').html(scene1);
								}else if(graphic1){
								   $('.out1').html(graphic1);
								}else{
								     $('.out1').html(processing1);
								}
					      	$('.out2').html(out2);
					      	$('.out3').html(out3);
					      	$('.out4').html(out4);
					      	$('.out5').html(out5);
					      	$('.memory1').html(scene1);
					      	$('.memory2').html(scene1);
					      	$('.memory3').html(scene2);
					      	$('.memory4').html(scene4);
					      	$('.speed1').html(processing1);
					      	$('.speed1').html(processing1);
					      	$('.speed2').html(processing2);
					      	$('.speed3').html(processing3);
					      	$('.understanding').html(know);
					      	$('.lastpostscript').html(postscript);
					      	$('.reasoning1').html(graphic1);
					      	$('.reasoning2').html(graphic1);
					      	$('.reasoning3').html(graphic3);
					      	$('.reasoning4').html(graphic5);
				    });
					},600)
				},
				// 关闭按钮
				print_close(){
					window.close();
				},
				print_page() {
					window.print();
				},
			},//methods
			created() {
			    	 //报告首页
			    	  var token = localStorage.getItem('token')
		    	 	this.$http.post(urls.urlReport + '/game/indexReport.json', {
					// token:localStorage.getItem('admintoken') == null?localStorage.getItem('token'):localStorage.getItem('admintoken'),
					 token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						// console.log(res.body)
						this.getPrintPageFirst = res.body//报告单首页信息
					})
					//您知道吗
					 var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/game/getTalent.json', {
					   token:token,
					eid: localStorage.getItem('eid')
					}).then(function(res) {
						// console.log(res.body)
						this.getTalentyou = res.body//记忆达人  灵活达人 言语大人 逻辑达人
					})
			},
	}
</script>


// WEBPACK FOOTER //
// mechanismPrin.vue?5f556fe8